module.exports = __webpack_public_path__ + "media/images/sample-badge-538510cf9d878a92f4b3ce2b38080b08.png";